//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { asyncDataCatch, asyncDataStart } from '~/utils/asyncData'

import { Breadcrumbs } from '~/plugins/breadcrumbs'
import BlogMenu from '~/components/section/blog-menu'
import RequestAction from '~/components/global/RequestAction.vue'
import BlogSearch from '~/components/form/blog-search'
import PaginationComponent from '~/components/global/PaginationComponent'
import OtherLocations from '~/components/seo/other-locations.vue'
import OffersInMailbox from '~/components/section/offers-in-mailbox'
import {mapGetters} from "vuex";

export default {
  name: 'BlogsCategory',
  components: {
    OtherLocations,
    BlogSearch,
    BlogMenu,
    RequestAction,
    PaginationComponent,
    OffersInMailbox
  },
  async asyncData (ctx) {
    await asyncDataStart(ctx)
    const breadcrumbs = []
    try {
      let page = null
      const lang = ctx.store.getters['lang/locale']
      let location = ctx.route.params.location || ''
      if (location) {
        location = location.replace('in-', '')
      }
      let pageNum = null
      if (ctx.route.params.page) {
        pageNum = ctx.route.params.page
      }
      const { data } = await ctx.$axios.get('/api/blogs/category/' + ctx.route.params.category + '?lang=' + lang + '&location=' + location + '&page=' + pageNum)
      page = data

      if (Object.keys(page).length === 0) {
        return await ctx.redirect(301, `/${lang}/blog/`)
      }

      if (ctx.route.params.category !== page.data.slug || (page.location && ctx.route.params.location !== page.location.urls[page.location.type])) {
        const loc = page.location && page.location.urls ? 'in-' + page.location.urls[page.location.type] : null
        const newUrl = ctx.app.router.resolve({
          name: 'blogs-category',
          params: { page: pageNum, category: page.data.slug, location: loc }
        }).href
        if (!process.client) {
          ctx.redirect(301, newUrl)
        }
      }

      breadcrumbs.push({
        title: 'Blogs',
        url: `${ctx.store.getters['lang/locale']}/blog/`
      })

      breadcrumbs.push({
        title: page.data.title || page.name,
        url: `${ctx.store.getters['lang/locale']}/blog/${page.data.slug}/`
      })

      const crubms = await Breadcrumbs.get(ctx.app.i18n, 'page', ctx.route, breadcrumbs)
      await ctx.store.dispatch('setBreadcrumbs', crubms)

      ctx.store.commit('SET_META_HEAD', {
        title: page.data?.meta_title,
        meta: [
          { name: 'title', property: 'og:title', hid: 'title', content: page.data?.meta_title },
          { name: 'description', property: 'og:description', hid: 'description', content: page.data?.meta_description },
          { name: 'twitter:title', content: page.data?.meta_title },
          { name: 'author', content: 'Tubber' },
          { name: 'twitter:description', content: page.data?.meta_description }
        ],
        link: []
      })

      return {
        lang,
        page,
        location
      }
    } catch (e) {
      return asyncDataCatch(ctx, e)
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$Search.resetAllAttributes(true)
    next()
  },
  head () {
    return {
      title: this.page?.data.meta_title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.page?.data.meta_description
        }
      ],
      link: [
        ...this.getAlternate
      ]
    }
  },
  computed: {
    ...mapGetters({
      check: 'auth/user'
    }),
    getBaseLink () {
      let path = ''
      const parts = this.$route.path.split('/')
      if (this.$route.params.page) {
        parts.pop()
        parts.pop()
      }
      parts.forEach((p) => {
        return (p !== '' ? path += '/' + p : '')
      })
      return process.env.appUrl + path + '/'
    },
    getAlternate () {
      return this.page?.data?.alternate.map((alt) => {
        return {
          rel: 'alternate',
          hreflang: alt.lang,
          href: alt.url
        }
      }) || []
    },
    menuCategories () {
      return this.page.categories.filter((cat) => {
        return cat.in_menu === 1
      })
    }
  },
  methods: {
    async onSetPage (page) {
      this.$scrollTo({ y: 250 })
      const { data } = await this.$axios.get('/api/blogs/category/' + this.$route.params.category + '?lang=' + this.lang + '&location=' + this.location + '&page=' + page)
      this.page.blogs = data.blogs
      this.page.page = data.page
      if (page === 1) {
        page = null
      }
      window.history.replaceState({},
        document.title,
        this.$router.resolve({
          name: 'blogs-category',
          params: { page, category: this.$route.params.category, location: this.$route.params.location}
        }).href)
    }
  }
}
